import React from 'react';
import { takeData } from '../components/gamedata.jsx';


class GamePage extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            minStarNum: 0,
            loading: true
        };
        this.app = null;
        this.spritesheet = null;
        this.keydownHandler = null;
        this.keyupHandler = null;
    }
    componentDidMount() {
        takeData('play', this.props.uid, this.props.projectId)
            .then((res) => {
                this.setState({ loading: false });
                //view
                const pixel = 32;
                const stage = { w: 640, h: 480 };
                const chaPos = { x: res.chara.x, y: res.chara.y };
                const boundInfo = { w: pixel * res.map.w, h: pixel * res.map.h };
                const doorInfo = { x: res.door.x, y: res.door.y };
                const wallInfo = res.walls;
                const starInfo = res.stars;
                this.setState({
                    minStarNum: res.map.starMinNum
                });

                //controller
                let pressKey = { keyLeft: false, keyRight: false, keyJump: false };

                // Physics constants
                const GRAVITY = 0.8;
                const JUMP_VELOCITY = -11;
                const MAX_FALL_SPEED = 12;

                let velocityY = 0;
                let onGround = false;
                let canJump = true;

                let map = { floor: boundInfo.h - pixel, end: false };
                let charaStatus = { speed: 1.8 };
                let landingY = boundInfo.h - pixel * 2 + 1;

                //view
                const app = new PIXI.Application({
                    background: '#1099bb',
                    width: stage.w,
                    height: stage.h,
                });
                this.app = app;
                app.view.setAttribute('id', 'canvas');
                const gameWindow = document.getElementById("game-window");
                if (!gameWindow) return;
                gameWindow.appendChild(app.view);
                const scene = new PIXI.Container();

                //background
                const bgTexture = PIXI.Texture.from('../image/bg.jpg');
                const bg1 = new PIXI.Sprite(bgTexture);
                const bg2 = new PIXI.Sprite(bgTexture);
                bg1.position.set(0, 0);
                bg2.position.set(640, 0);
                app.stage.addChild(bg1);
                app.stage.addChild(bg2);

                //bound
                const bounds = new PIXI.ParticleContainer();
                const upBounds = new PIXI.ParticleContainer();
                const boundWidthNum = boundInfo.w / pixel;
                const boundHeightNum = boundInfo.h / pixel;
                const boundTexture = PIXI.Texture.from('../image/bound.jpg');
                for (let i = 0; i < boundWidthNum; i++) {
                    let bound = new PIXI.Sprite(boundTexture);
                    bound.position.set(pixel * i, 0);
                    upBounds.addChild(bound);
                    bound = new PIXI.Sprite(boundTexture);
                    bound.position.set(pixel * i, boundInfo.h - pixel);
                    bounds.addChild(bound);
                }
                for (let i = 1; i < boundHeightNum - 1; i++) {
                    let bound = new PIXI.Sprite(boundTexture);
                    bound.position.set(0, pixel * i);
                    bounds.addChild(bound);
                    bound = new PIXI.Sprite(boundTexture);
                    bound.position.set(boundInfo.w - pixel, pixel * i);
                    bounds.addChild(bound);
                }
                scene.addChild(upBounds);
                scene.addChild(bounds);

                //door
                const doorCloseTexture = PIXI.Texture.from('../image/door_close.png');
                const doorClose = new PIXI.Sprite(doorCloseTexture);
                doorClose.position.set(doorInfo.x, doorInfo.y);
                if (res.door.x > 0) {
                    scene.addChild(doorClose);
                }

                const doorOpenTexture = PIXI.Texture.from('../image/door_open.png');
                const doorOpen = new PIXI.Sprite(doorOpenTexture);
                doorOpen.position.set(doorInfo.x, doorInfo.y);
                if (res.door.x > 0) {
                    scene.addChild(doorOpen);
                }
                if (res.map.starMinNum == 0) {
                    doorClose.visible = false;
                } else {
                    doorOpen.visible = false;
                }


                //wall
                let wallsGroup = [];
                const wallTexture = PIXI.Texture.from('../image/wall.jpeg');
                wallInfo.forEach(function (info) {
                    const bricks = new PIXI.ParticleContainer();
                    for (let i = 0; i < info.num; i++) {
                        const brick = new PIXI.Sprite(wallTexture);
                        brick.position.set(pixel * i, 0);
                        bricks.addChild(brick);
                    }
                    bricks.position.set(info.x, info.y);
                    scene.addChild(bricks);
                    const walls = {
                        id: info.num,
                        wall: bricks,
                        isUp: false,
                        isRight: false,
                        isMiddle: false
                    };
                    wallsGroup.push(walls);
                });
                const upBoundGroup = {
                    id: boundWidthNum,
                    wall: upBounds,
                    isUp: false,
                    isRight: false,
                    isMiddle: false
                };
                wallsGroup.push(upBoundGroup);

                //star
                const scoreNum = document.getElementById("score-number");
                let score = 0;
                let starGroup = [];
                let starTexture = PIXI.Texture.from('../image/star.png');
                starInfo.forEach(function (info) {
                    const star = new PIXI.Sprite(starTexture);
                    star.position.set(info.x - 16, info.y - 16);
                    scene.addChild(star);
                    const stars = {
                        star: star,
                        exist: info.exist
                    }
                    starGroup.push(stars);
                });
                app.stage.addChild(scene);

                //character
                const atlasData = {
                    frames: {
                        left1: {
                            frame: { x: 0, y: 32, w: 32, h: 32 },
                            sourceSize: { w: 32, h: 32 },
                            spriteSourceSize: { x: 0, y: 0, w: 32, h: 32 }
                        },
                        left2: {
                            frame: { x: 32, y: 32, w: 32, h: 32 },
                            sourceSize: { w: 32, h: 32 },
                            spriteSourceSize: { x: 0, y: 0, w: 32, h: 32 }
                        },
                        left3: {
                            frame: { x: 64, y: 32, w: 32, h: 32 },
                            sourceSize: { w: 32, h: 32 },
                            spriteSourceSize: { x: 0, y: 0, w: 32, h: 32 }
                        },
                        right1: {
                            frame: { x: 0, y: 64, w: 32, h: 32 },
                            sourceSize: { w: 32, h: 32 },
                            spriteSourceSize: { x: 0, y: 0, w: 32, h: 32 }
                        },
                        right2: {
                            frame: { x: 32, y: 64, w: 32, h: 32 },
                            sourceSize: { w: 32, h: 32 },
                            spriteSourceSize: { x: 0, y: 0, w: 32, h: 32 }
                        },
                        right3: {
                            frame: { x: 64, y: 64, w: 32, h: 32 },
                            sourceSize: { w: 32, h: 32 },
                            spriteSourceSize: { x: 0, y: 0, w: 32, h: 32 }
                        },
                    },
                    meta: {
                        image: '../image/cha.png',
                        format: 'RGBA8888',
                        size: { w: 96, h: 128 },
                        scale: 1
                    },
                    animations: {
                        left: ['left2', 'left3', 'left1'],
                        right: ['right2', 'right3', 'right1']
                    }
                }

                // Remove cached textures from previous instances to avoid warnings
                Object.keys(atlasData.frames).forEach(id => {
                    PIXI.Texture.removeFromCache(id);
                });

                const spritesheet = new PIXI.Spritesheet(
                    PIXI.BaseTexture.from(atlasData.meta.image),
                    atlasData
                );
                this.spritesheet = spritesheet;
                spritesheet.parse();
                const walkLeft = new PIXI.AnimatedSprite(spritesheet.animations.left);
                const walkRight = new PIXI.AnimatedSprite(spritesheet.animations.right);
                walkLeft.animationSpeed = 0.1666;
                walkRight.animationSpeed = 0.1666;

                const stopRight = new PIXI.Sprite(spritesheet.textures.right2);
                const stopLeft = new PIXI.Sprite(spritesheet.textures.left2);
                const chara = new PIXI.Container();

                chara.addChild(stopRight);
                chara.addChild(stopLeft);
                chara.addChild(walkRight);
                chara.addChild(walkLeft);

                stopLeft.visible = false;
                stopRight.visible = false;
                walkLeft.visible = false;
                walkRight.visible = true;
                chara.position.set(chaPos.x, chaPos.y);
                chara.width = 30;
                if (res.chara.x > 0) {
                    app.stage.addChild(chara);
                }

                const endScene = new PIXI.Container();
                const successMsg = new PIXI.Container();
                let rectangle = new PIXI.Graphics();
                rectangle.lineStyle(4, 0xFFFFFF, 1);
                rectangle.beginFill(0x444444);
                rectangle.drawRoundedRect(0, 0, pixel * 10, pixel * 6, 10);
                rectangle.endFill();
                successMsg.addChild(rectangle);

                let style = new PIXI.TextStyle({
                    fontFamily: "Cubic",
                    fontSize: 36,
                    fill: "white"
                });
                let message = new PIXI.Text("恭喜通關", style);
                message.position.set(pixel * 2.5, pixel * 2.5)
                successMsg.addChild(message);
                successMsg.position.set(pixel * 5, pixel * 3);
                endScene.addChild(successMsg);
                endScene.visible = false;
                app.stage.addChild(endScene);

                //controller
                function init() {
                    initScenePos();
                    // Start with gravity active (character falls to ground)
                    velocityY = 0;
                    onGround = false;
                    app.ticker.add(delta => gameLoop(delta));
                }
                init();

                function initScenePos() {
                    let x;
                    if (chara.x - stage.w * 0.5 <= 0) x = 0;
                    else if (chara.x + chara.width + stage.w * 0.5 >= boundInfo.w) x = stage.w - boundInfo.w;
                    else x = stage.w * 0.5 - chara.x;

                    let y;
                    if (chara.y - stage.h * 0.5 <= 0) y = 0;
                    else if (chara.y + chara.height + stage.h * 0.5 >= boundInfo.h) y = stage.h - boundInfo.h;
                    else y = stage.h * 0.5 - chara.y;

                    scene.position.set(x, y);
                    chara.x += x;
                    chara.y += y;
                }

                function gameLoop(delta) {
                    gameStatus();
                    if (!map.end) {
                        showScene();
                    }
                    chaMove(delta);
                }

                function gameStatus() {
                    if (doorOpen.visible &&
                        boxesIntersect(chara, doorOpen) &&
                        (chara.x > doorOpen.getGlobalPosition().x) &&
                        (chara.x - 16 < doorOpen.getGlobalPosition().x)) {
                        scene.visible = false;
                        endScene.visible = true;
                        doorOpen.visible = false;
                        map.end = true;
                    }
                    bg1.x -= 0.5;
                    bg2.x -= 0.5;
                    if (bg1.x == -640)
                        bg1.x = 640;
                    if (bg2.x == -640)
                        bg2.x = 640;
                }

                function showScene() {
                    let floorWallY = map.floor;
                    let hitCeiling = false;
                    let hitLeft = false;
                    let hitRight = false;

                    wallsGroup.forEach(walls => {
                        const wallGX = walls.wall.getGlobalPosition().x;
                        const wallGY = walls.wall.getGlobalPosition().y;
                        const wallW = walls.wall.width;
                        const wallH = walls.wall.height;

                        // Skip walls too far away
                        if (chara.x + chara.width < wallGX - 5 ||
                            chara.x > wallGX + wallW + 5) return;
                        if (wallGY > chara.y + chara.height + 50) return;

                        const overlapX = chara.x + chara.width - 5 > wallGX &&
                                         chara.x + 5 < wallGX + wallW;

                        // Landing on top of wall (character above wall, moving down)
                        if (overlapX &&
                            chara.y + chara.height <= wallGY + 8 &&
                            chara.y + chara.height + velocityY >= wallGY - 2) {
                            if (wallGY < floorWallY) {
                                floorWallY = wallGY;
                            }
                        }

                        // Hitting ceiling (character below wall, moving up)
                        if (overlapX &&
                            velocityY < 0 &&
                            chara.y >= wallGY + wallH - 4 &&
                            chara.y + velocityY < wallGY + wallH) {
                            hitCeiling = true;
                            chara.y = wallGY + wallH;
                        }

                        // Side collisions
                        if (chara.y + chara.height > wallGY + 4 &&
                            chara.y < wallGY + wallH - 4) {
                            // Hit right side of wall
                            if (chara.x < wallGX + wallW &&
                                chara.x + chara.width > wallGX + wallW &&
                                chara.x + 5 < wallGX + wallW) {
                                chara.x = wallGX + wallW;
                                hitLeft = true;
                            }
                            // Hit left side of wall
                            if (chara.x + chara.width > wallGX &&
                                chara.x < wallGX &&
                                chara.x + chara.width - 5 > wallGX) {
                                chara.x = wallGX - chara.width;
                                hitRight = true;
                            }
                        }
                    });

                    landingY = floorWallY - chara.height + 1;

                    if (hitCeiling && velocityY < 0) {
                        velocityY = 0;
                    }

                    starGroup.forEach(star => {
                        if (star.exist) detectStar(star);
                    });
                }

                function detectStar(star) {
                    if (boxesIntersect(chara, star.star) &&
                        (chara.x + 20 > star.star.getGlobalPosition().x) &&
                        (chara.x - 10 < star.star.getGlobalPosition().x)) {
                        star.star.visible = false;
                        star.exist = false;
                        score++;
                        if (scoreNum) scoreNum.innerHTML = score;
                        if (score >= res.map.starMinNum) {
                            doorOpen.visible = true;
                        }
                    }
                }

                function chaMove(delta) {
                    // Horizontal movement
                    if (pressKey.keyLeft) {
                        closeMainChaPic(walkLeft);
                        let cameraMove = camera('left', charaStatus.speed * delta);
                        if (!cameraMove) chara.x -= charaStatus.speed * delta;
                    }
                    if (pressKey.keyRight) {
                        closeMainChaPic(walkRight);
                        let cameraMove = camera('right', charaStatus.speed * delta);
                        if (!cameraMove) chara.x += charaStatus.speed * delta;
                    }

                    // Apply gravity
                    velocityY += GRAVITY * delta;
                    if (velocityY > MAX_FALL_SPEED) {
                        velocityY = MAX_FALL_SPEED;
                    }

                    // Apply vertical movement
                    let cameraMove = camera('jump', velocityY * delta);
                    if (!cameraMove) {
                        chara.y += velocityY * delta;
                    }

                    // Ground check
                    if (chara.y >= landingY) {
                        chara.y = landingY;
                        velocityY = 0;
                        onGround = true;
                        canJump = true;
                    } else {
                        onGround = false;
                    }
                }

                this.keydownHandler = function (e) {
                    if (e.key === "ArrowLeft") {
                        pressKey.keyLeft = true;
                        walkLeft.play();
                    }
                    if (e.key === "ArrowRight") {
                        pressKey.keyRight = true;
                        walkRight.play();
                    }
                    if (e.key === " " && canJump && onGround) {
                        velocityY = JUMP_VELOCITY;
                        onGround = false;
                        canJump = false;
                    }
                };
                this.keyupHandler = function (e) {
                    if (e.key === "ArrowLeft") {
                        pressKey.keyLeft = false;
                        closeMainChaPic(stopLeft);
                        walkLeft.stop();
                    }
                    if (e.key === "ArrowRight") {
                        pressKey.keyRight = false;
                        closeMainChaPic(stopRight);
                        walkRight.stop();
                    }
                    if (e.key === " ") {
                        canJump = true;
                        // Cut jump short if released early (variable jump height)
                        if (velocityY < JUMP_VELOCITY * 0.4) {
                            velocityY = JUMP_VELOCITY * 0.4;
                        }
                    }
                };
                document.addEventListener('keydown', this.keydownHandler);
                document.addEventListener('keyup', this.keyupHandler);

                function camera(status, speed) {
                    switch (status) {
                        case 'right':
                            if (chara.x >= stage.w - pixel * 2) {
                                chara.x = stage.w - pixel * 2;
                                return false;
                            } else if (chara.x >= stage.w - pixel * 3
                                && stage.w - boundInfo.w < scene.x) {
                                scene.x -= speed;
                                if (stage.w - boundInfo.w > scene.x)
                                    scene.x = stage.w - boundInfo.w;
                                return true;
                            }
                            return false;
                        case 'left':
                            if (chara.x < pixel) {
                                chara.x = pixel;
                                return false;
                            } else if (chara.x <= pixel * 2
                                && scene.x < 0) {
                                scene.x += speed;
                                if (scene.x > 0)
                                    scene.x = 0;
                                return true;
                            }
                            return false;
                        case 'jump':
                            // Camera follows vertically
                            if (speed < 0 && chara.y <= pixel * 3 && scene.y < 0) {
                                scene.y -= speed;
                                chara.y -= speed;
                                if (scene.y >= 0) {
                                    scene.y = 0;
                                    return false;
                                }
                                return true;
                            }
                            if (chara.y >= stage.h - pixel * 2) {
                                return false;
                            } else if (speed > 0 && chara.y >= stage.h - pixel * 3
                                && stage.h - boundInfo.h < scene.y) {
                                scene.y += speed;
                                chara.y += speed;
                                if (stage.h - boundInfo.h > scene.y)
                                    scene.y = stage.h - boundInfo.h;
                                return true;
                            }
                            return false;
                    }
                }

                function closeMainChaPic(obj) {
                    stopLeft.visible = false;
                    stopRight.visible = false;
                    walkLeft.visible = false;
                    walkRight.visible = false;
                    obj.visible = true;
                }

                function boxesIntersect(a, b) {
                    let ab = a.getBounds();
                    let bb = b.getBounds();
                    return ab.x + ab.width > bb.x &&
                        ab.x < bb.x + bb.width &&
                        ab.y + ab.height > bb.y &&
                        ab.y < bb.y + bb.height;
                }
            })
            .catch((err) => {
                console.log(err);
            });
    }

    componentWillUnmount() {
        if (this.keydownHandler) {
            document.removeEventListener('keydown', this.keydownHandler);
        }
        if (this.keyupHandler) {
            document.removeEventListener('keyup', this.keyupHandler);
        }
        if (this.spritesheet) {
            this.spritesheet.destroy(true);
            this.spritesheet = null;
        }
        if (this.app) {
            this.app.destroy(true, { children: true, texture: false, baseTexture: false });
            this.app = null;
        }
    }

    render() {
        return (
            <div id="game-window">
                {this.state.loading && (
                    <div className="game-loading">
                        <div className="game-loading-blocks">
                            <span></span><span></span><span></span>
                        </div>
                        <p className="game-loading-text">Loading</p>
                    </div>
                )}
                <div id="score">
                    <img src="../image/starTool.png" alt="" />
                    <div>x <span id="score-number">0</span>
                        <p className='score-slash'>/<span id="score-goal">{this.state.minStarNum}</span></p>
                    </div>
                </div>
            </div>
        )
    }
}

export default GamePage;
